import VerticalMenu from './VerticalMenu';

export default VerticalMenu;
